<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas"
               [value]="this.obtenerCampanias()" selectionMode="single" dataKey="idCampaniaDctoCiclos"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.numeroCiclo}}</td>
            <td>{{ row.indicadorSuma ? '+ ' + row.descuentoTasa : '- ' + row.descuentoTasa }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="grid form-footer-buttons" *ngIf="campania && campania.idCampania">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar()"></button>
        </div>
      </div>
    </div>
  </div>

</div>

